import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { AxiosResponse } from "axios";
import { TResponse } from "../../../types/common";

export interface INotificationItem {
  _id: string;
  title: string;
  message: string;
  type: string;
  read: boolean;
  metadata?: any;
  createdAt: string;
  updatedAt: string;
}

export async function fetchNotifications(): Promise<AxiosResponse<TResponse<INotificationItem[]>>> {
  return axios.get<TResponse<INotificationItem[]>>(API_ENDPOINTS.NOTIFICATION_LIST);
}

export async function fetchUnreadNotificationCount(): Promise<AxiosResponse<TResponse<{ unreadCount: number }>>> {
  return axios.get<TResponse<{ unreadCount: number }>>(`${API_ENDPOINTS.NOTIFICATION_LIST}/unread-count`);
}

export async function markNotificationAsRead(id: string): Promise<AxiosResponse<TResponse<any>>> {
  return axios.patch<TResponse<any>>(`${API_ENDPOINTS.NOTIFICATION_LIST}/${id}/read`);
}

export async function markAllNotificationsAsRead(): Promise<AxiosResponse<TResponse<any>>> {
  return axios.patch<TResponse<any>>(`${API_ENDPOINTS.NOTIFICATION_LIST}/read-all`);
}
